var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box, Button, Flex, Hide, Text } from 'pcln-design-system';
import Badges from './Badges';
import CardContainer from './CardContainer';
import Logo from './Logo';
import ProductIcon from '../ProductIcon/ProductIcon';
import { PRODUCT_ICONS } from '../constants/productIcons';
var CONDENSED_HEIGHT = 232;
var CONDENSED_WIDTH = 324;
var FULL_HEIGHTS = {
  sm: 240,
  lg: 136,
  xl: 296
};
var FULL_WIDTH = 360;
var ICON_SIZE_LARGE = '40px';
var ICON_SIZE_SMALL = '32px';
var LOGO_WIDTHS = {
  sm: 80,
  md: 184,
  lg: 224
};
var CardButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "MediaImageCard__CardButton",
  componentId: "sc-621ly7-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var OuterBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "MediaImageCard__OuterBox",
  componentId: "sc-621ly7-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-shadow: ", ";\n\n  ", "\n"], ["\n  box-shadow: ", ";\n\n  ", "\n"])), themeGet('shadows.md'), function (props) {
  return props.url ? "\n    transition: box-shadow ".concat(themeGet('timingFunctions.easeInOut')(props), " ").concat(themeGet('duration.normal')(props), ";\n    &:hover {\n      box-shadow: ").concat(themeGet('shadows.xl')(props), ";\n    }\n  ") : '';
});
var ShadowFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "MediaImageCard__ShadowFlex",
  componentId: "sc-621ly7-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"
/** @public */])), function (props) {
  return props.showGradient ? 'background-image: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.01) 100%)' : '';
});
/** @public */
function MediaImageCard(_a) {
  var _b = _a.isAlwaysVertical,
    isAlwaysVertical = _b === void 0 ? false : _b,
    backgroundColor = _a.backgroundColor,
    backgroundImageUrl = _a.backgroundImageUrl,
    badgeColor = _a.badgeColor,
    badgeText = _a.badgeText,
    borderText = _a.borderText,
    callToActionColor = _a.callToActionColor,
    callToAction = _a.callToAction,
    _c = _a.contentAlign,
    contentAlign = _c === void 0 ? 'default' : _c,
    fixedLogoSize = _a.fixedLogoSize,
    heading = _a.heading,
    height = _a.height,
    icon = _a.icon,
    _d = _a.isCondensed,
    isCondensed = _d === void 0 ? false : _d,
    logoImageUrl = _a.logoImageUrl,
    minHeight = _a.minHeight,
    _e = _a.showBorder,
    showBorder = _e === void 0 ? false : _e,
    lazyLoad = _a.lazyLoad,
    _f = _a.showLogoImageBackground,
    showLogoImageBackground = _f === void 0 ? true : _f,
    subheading = _a.subheading,
    _g = _a.textColor,
    textColor = _g === void 0 ? 'text.lightest' : _g,
    width = _a.width;
  var _h = callToAction || {},
    ariaLabel = _h.ariaLabel,
    contentTypeId = _h.contentTypeId,
    label = _h.label,
    openInNewTab = _h.openInNewTab,
    url = _h.url,
    onClick = _h.onClick;
  var buttonColor = callToActionColor || 'primary';
  if (callToActionColor && callToActionColor.includes('.')) {
    buttonColor = callToActionColor.substring(0, callToActionColor.indexOf('.'));
  }
  var cardWidth = width ? width : isCondensed ? [1, null, CONDENSED_WIDTH] : [1, null, FULL_WIDTH];
  var cardHeight = height ? height : isCondensed ? CONDENSED_HEIGHT : FULL_HEIGHTS.xl;
  var cardMinHeight = minHeight ? minHeight : isAlwaysVertical ? [FULL_HEIGHTS.sm, null, null, null, cardHeight] : [FULL_HEIGHTS.sm, null, FULL_HEIGHTS.lg, null, cardHeight];
  var hasBackgroundImage = backgroundImageUrl && typeof backgroundImageUrl === 'string';
  var hasBadges = Boolean(badgeText || borderText);
  var buttonVariation = hasBackgroundImage ? 'fill' : 'white';
  var isButtonCta = contentTypeId === 'button';
  var isTransparent = !backgroundImageUrl && !backgroundColor;
  var isContrastEnabled = (isTransparent || hasBackgroundImage) && Boolean(heading || subheading);
  var isCenterAligned = contentAlign === 'center';
  var fullWidthHideProps = isAlwaysVertical ? {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  } : {
    xs: true,
    sm: true,
    xl: true,
    xxl: true
  };
  var cardProps = __assign({
    ariaLabel: ariaLabel,
    backgroundImageUrl: backgroundImageUrl,
    borderRadius: 'xl',
    color: hasBackgroundImage ? undefined : backgroundColor,
    openInNewTab: openInNewTab,
    p: ['12px', null, null, null, 3],
    url: url,
    onClick: onClick
  }, showBorder ? {
    borderColor: 'background.lightest',
    borderStyle: 'solid',
    borderWidth: 4
  } : {
    borderWidth: 0
  });
  var textProps = {
    textAlign: isCenterAligned ? isAlwaysVertical ? 'center' : ['center', null, 'left', null, 'center'] : 'left',
    color: textColor,
    enableTextShadow: isContrastEnabled,
    textShadowSize: 'sm'
  };
  var showIcon = icon && PRODUCT_ICONS.includes(icon);
  var iconNode = showIcon ? React.createElement(Flex, {
    justifyContent: isCenterAligned ? 'center' : 'right',
    width: isCenterAligned ? 1 : undefined
  }, React.createElement(ProductIcon, {
    type: icon,
    backgroundColor: 'primary.light',
    height: [ICON_SIZE_SMALL, null, null, null, ICON_SIZE_LARGE],
    width: [ICON_SIZE_SMALL, null, null, null, ICON_SIZE_LARGE]
  })) : null;
  return React.createElement(Flex, {
    width: 1
  }, React.createElement(Hide, {
    md: !isAlwaysVertical,
    lg: !isAlwaysVertical,
    width: 1
  }, React.createElement(OuterBox, {
    borderRadius: 'xl',
    minHeight: cardMinHeight,
    url: url,
    width: cardWidth
  }, React.createElement(CardContainer, __assign({}, cardProps, {
    flexDirection: 'column',
    minHeight: cardMinHeight,
    showGradient: isContrastEnabled
  }), React.createElement(Flex, {
    flexDirection: 'column',
    width: 1
  }, React.createElement(Badges, {
    badgeColor: badgeColor,
    badgeText: badgeText,
    borderText: borderText,
    textColor: textColor
  }), logoImageUrl && React.createElement(Flex, {
    justifyContent: 'center'
  }, React.createElement(Logo, {
    isCondensed: isCondensed,
    fixedLogoSize: fixedLogoSize,
    logoImageUrl: logoImageUrl,
    lazyLoad: lazyLoad,
    showLogoImageBackground: showLogoImageBackground,
    p: 2,
    width: isCondensed ? LOGO_WIDTHS.md : [LOGO_WIDTHS.md, null, LOGO_WIDTHS.lg]
  }))), React.createElement(Flex, {
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '100%'
  }, isCenterAligned && iconNode, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: isCenterAligned ? 'center' : 'space-between',
    mt: 2,
    width: '100%'
  }, React.createElement(Flex, null, React.createElement(Flex, {
    alignItems: isCenterAligned ? 'center' : 'baseline',
    flexDirection: 'column',
    pr: isButtonCta || showIcon ? 1 : undefined
  }, React.createElement(Text, __assign({
    textStyle: isCondensed ? 'heading5' : ['heading5', null, null, null, 'heading4']
  }, textProps), heading), React.createElement(Text, __assign({
    textStyle: isCondensed ? 'subheading6' : ['subheading6', null, null, null, 'subheading5'],
    mt: 1
  }, textProps), subheading), React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: isCenterAligned ? 'center' : undefined,
    mt: [1, null, null, null, 2],
    pt: 2
  }, isButtonCta && React.createElement(CardButton, {
    "aria-label": ariaLabel,
    color: buttonColor,
    size: 'small',
    variation: buttonVariation
  }, label)))), !isCenterAligned && iconNode))))), React.createElement(Hide, __assign({}, fullWidthHideProps, {
    width: 1
  }), React.createElement(Box, {
    borderRadius: 'xl',
    height: '100%',
    minHeight: cardMinHeight,
    width: 1
  }, React.createElement(CardContainer, __assign({}, cardProps, {
    minHeight: cardMinHeight,
    p: '12px'
  }), (logoImageUrl || badgeText || borderText) && React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: ['auto', 224],
    pr: [1, null, 2],
    mr: 1
  }, React.createElement(Badges, {
    badgeColor: badgeColor,
    badgeText: badgeText,
    borderText: borderText,
    textColor: textColor,
    pb: '12px'
  }), logoImageUrl && React.createElement(Flex, {
    alignItems: hasBadges ? 'flex-end' : undefined,
    height: '100%',
    justifyContent: 'flex-start'
  }, React.createElement(Logo, {
    fixedLogoSize: fixedLogoSize,
    lazyLoad: lazyLoad,
    isCondensed: hasBadges,
    logoImageUrl: logoImageUrl,
    minHeight: hasBadges ? showBorder ? 70 : 78 : undefined,
    px: 0,
    showLogoImageBackground: showLogoImageBackground,
    width: hasBadges ? [LOGO_WIDTHS.sm, LOGO_WIDTHS.md, LOGO_WIDTHS.lg] : LOGO_WIDTHS.lg
  }))), React.createElement(ShadowFlex, {
    alignItems: 'center',
    borderRadius: 'lg',
    flexDirection: 'column',
    minHeight: '100%',
    justifyContent: 'flex-end',
    showGradient: isContrastEnabled,
    width: 1
  }, React.createElement(Flex, {
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'space-between',
    p: '12px',
    width: '100%'
  }, React.createElement(Flex, null, React.createElement(Flex, {
    flexDirection: 'column'
  }, React.createElement(Text, __assign({
    textStyle: 'heading5'
  }, textProps), heading), React.createElement(Text, __assign({
    textStyle: 'subheading6',
    mt: 1
  }, textProps), subheading))), React.createElement(Flex, {
    alignItems: isCenterAligned ? 'center' : 'flex-start',
    flexDirection: 'column',
    width: 'unset'
  }, React.createElement(Flex, {
    alignItems: 'center',
    pt: 1,
    ml: 1
  }, isButtonCta && React.createElement(Box, null, React.createElement(CardButton, {
    "aria-label": ariaLabel,
    color: buttonColor,
    size: 'small',
    variation: buttonVariation
  }, label)), showIcon && React.createElement(Box, {
    ml: 1,
    pl: 2
  }, iconNode)))))))));
}
export default MediaImageCard;
var templateObject_1, templateObject_2, templateObject_3;